var exports = {
  "kL": "AttachmentFile.module__container___djFWZz",
  "G5": "AttachmentFile.module__deleteButton___djFWZz",
  "Dq": "AttachmentFile.module__attachmentContainer___djFWZz",
  "zc": "AttachmentFile.module__iconContainer___djFWZz",
  "el": "AttachmentFile.module__fileInfoContainer___djFWZz",
  "Md": "AttachmentFile.module__fileName___djFWZz",
  "m$": "AttachmentFile.module__fileNameTruncate___djFWZz",
  "i_": "AttachmentFile.module__fileExtension___djFWZz",
  "Ov": "AttachmentFile.module__fileSize___djFWZz",
  "l6": "AttachmentFile.module__downloadButton___djFWZz",
  "Hj": "AttachmentFile.module__downloadButtonDisabled___djFWZz",
};

module.exports = exports;
